import dayjs, { Dayjs } from 'dayjs'
import { t } from 'i18next'
import { HoursInterval } from '../types'

export const getIntervalSumString = ({ hours, minutes }: { hours: number; minutes: number }): string => {
  let sumString = t('page.schedule.fillOutManyPopup.sum')
  if (hours <= 0 && minutes <= 0) return sumString + '-'

  if (hours !== 0) sumString += t('page.schedule.fillOutManyPopup.hours', { count: hours })
  if (minutes !== 0) sumString += t('page.schedule.fillOutManyPopup.minutes', { count: minutes })

  return sumString
}

export const checkIfOverlapping = (fromTimeToCheck: Dayjs, toTimeToCheck: Dayjs, fromTime: Dayjs, toTime: Dayjs) => {
  const midnight = dayjs('00:00', 'HH:mm')
  if(toTimeToCheck.isSame(midnight, 'minute')){
    toTimeToCheck = toTimeToCheck.add(1, 'day')
  }
  if(toTime.isSame(midnight, 'minute')){
    toTime = toTime.add(1, 'day')
  }

  if (fromTimeToCheck.isBefore(fromTime) && toTimeToCheck.isAfter(toTime)) {
    return true
  }

  if (fromTimeToCheck.isAfter(fromTime) && toTimeToCheck.isBefore(toTime)) {
    return true
  }

  if (
    (fromTimeToCheck.isAfter(fromTime) && fromTimeToCheck.isBefore(toTime)) ||
    (toTimeToCheck.isAfter(fromTime) && toTimeToCheck.isBefore(toTime)) ||
    fromTimeToCheck.isSame(fromTime) ||
    toTimeToCheck.isSame(toTime)
  ) {
    return true
  }

  return false
}

export const checkIfTimePeriodOverlaps = (intervalToCheck: HoursInterval, intervals: HoursInterval[]): boolean => {
  const { from: fromToCheck, to: toToCheck } = intervalToCheck

  for (const interval of intervals) {
    if (interval.id !== intervalToCheck.id) {
      const { from, to } = interval

      if (
        checkIfOverlapping(
          dayjs(fromToCheck, 'HH:mm'),
          dayjs(toToCheck, 'HH:mm'),
          dayjs(from, 'HH:mm'),
          dayjs(to, 'HH:mm')
        )
      )
        return true
    }
  }

  return false
}

export const checkIfAnyTimePeriodOverlaps = (intervals: HoursInterval[]): boolean => {
  for (let i = 0; i < intervals.length; i++) {
    const { from: fromToCheck, to: toToCheck } = intervals[i]

    for (let j = i + 1; j < intervals.length; j++) {
      const { from, to } = intervals[j]

      if (
        checkIfOverlapping(
          dayjs(fromToCheck, 'HH:mm'),
          dayjs(toToCheck, 'HH:mm'),
          dayjs(from, 'HH:mm'),
          dayjs(to, 'HH:mm')
        )
      )
        return true
    }
  }

  return false
}

export const getDateFromTime = (time: string): Dayjs => {
  const [hour, minute] = time.split(':')

  let date = dayjs({ hour: +hour, minute: +minute })

  return date
}
